import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const AggreementChartStyles = makeStyles((theme) => ({
    cardRoot: {
        padding: '12px',
        borderRadius: theme.palette.borderRadius,
        border: "1px solid #E4E8EE",
        width: "100%"
    },
    title: {
        fontSize:"0.875rem",
        color: "#091B29",
        fontFamily: FontFamilySwitch().bold,

    },
    name: {
        fontSize:"0.75rem",
        color: "#091B29",
        display: "flex",
        alignItems: "center",
        marginTop: "4px",
    },
    value: {
        fontSize:"0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
        marginTop: "4px",
        direction: "ltr",
        textAlign: "-webkit-match-parent"
    }

}));